// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"ad9adc29","63":"d9f49e2b","133":"7538cb89","301":"b0c48be0","418":"0b0b413f","444":"6fdcc8fe","453":"340ff90f","682":"bb8af419","695":"7ca91437","735":"bde6370b"}[chunkId] + ".chunk.js";
};